<template lang="pug">
  article.section
    //- code {{post}}
    figure
      img(:src="post.featured_image_url", alt="")
      figcaption
        h2(v-html="post.title.rendered")
        .excerpt(v-html="post.excerpt.rendered")

</template>
<script>
export default {
  props: {
    post: Object
  },
  computed: {
    brTitle(){
      const ttext = this.title.trim();
      return ttext.replace(' ', '<br>')
    },
  }
}
</script>
<style lang="scss" scoped>
  .section{
    position: relative;
    img{
      max-width: 100%;
    }
  }
  span.more{
    padding: 1rem;
    display: block;
    &:after{
      content: '→';
      padding-left: 0.3rem;
      transition: all .3s;
    }
  }
  .section{
    &:hover{
      img{
        opacity: 1;
        transform: scale(1.008);
      }
    }
  }




</style>

